// John Eldhose 20200731
import React, { Component } from 'react';
import { Button, Grid, TextField, Typography } from '@material-ui/core';
import { Save } from '@material-ui/icons';
import { postAcademy } from './lib';

class Discussion extends Component {

  state = {
    loading: true,
    response: ''
  }
  discussion = [];
  componentWillMount() {
    postAcademy('data', { property: '_discussion', did: this.props.parms.id }, (res) => {
      this.discussion = res.data;
      this.setState({ loading: false });
    });
  }
  handleResponse = (e) => {
    if(this.state.response.length < 2500)
      this.setState({ response: e.target.value });
  }
  handleSave = () => {
    postAcademy('data', { property: '_discussion', did: this.props.parms.id, save: this.state.response }, (res) => { this.discussion = res.data; });
  }
  content = (disc, id) => {
    return (
      <div key={id}>
        <Grid container justify='space-around'>
          <Typography variant='subheading'>
            {disc.FirstName} {disc.LastName}
          </Typography>
          <Typography variant='caption'>
            Wrote on {disc.created}
          </Typography>
        </Grid>
        <Grid container justify='flex-start'>
          <Typography>
            {disc.data}
          </Typography>
        </Grid>
      </div>
    );
  }

  render() {
    return (
      <div style={{ padding: '30px 0' }}>
        <div style={{ border: 'solid silver 1px', padding: '10px' }}>
        <TextField
          fullWidth
          multiline
          rows='4'
          label='What do you think?'
          value={this.state.response}
          onChange={this.handleResponse}
          helperText={(2500 - this.state.response.length) + ' characters left'}
        />
        <Grid container justify='flex-end'>
          <Button variant='raised' color='primary' onClick={this.handleSave}>
            <Save /> &nbsp;Save
          </Button>
        </Grid>
        </div>
        <p />
        <Typography variant='title'>Discussions</Typography>
        <p />
        {this.discussion.map(this.content)}
      </div>
    );
  }
}

export default Discussion;



// WEBPACK FOOTER //
// ./src/components/home/academy/Discussion.js